module.exports = __webpack_public_path__ + "assets/img/activity-banner.f0585040.png";